// ═══════════════════════════════════════════════════════════════════════════
// TutorialFAB — botón flotante para grabar tutoriales (Bloque 5 — 26-may-2026)
// ───────────────────────────────────────────────────────────────────────────
// FAB siempre visible (bottom-right) si el usuario tiene permiso
// `tutoriales.grabar`. Posicionado arriba del DebugFAB (bottom-24 vs bottom-6)
// para que los dos puedan coexistir sin chocar.
//
// Click → abre el TutorialRecorder modal (Bloque 5 también) que orquesta el
// flujo completo de grabación + subida.
//
// El gating fino se hace via puede('tutoriales','grabar') del AuthContext —
// si no tiene permiso, el FAB ni se renderiza en el DOM (no es solo CSS,
// es un guard real).
// ═══════════════════════════════════════════════════════════════════════════

import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useAuth } from '@core/contexts/AuthContext'
import TutorialRecorder from '@modules/tutoriales/components/TutorialRecorder'

export default function TutorialFAB({ variant = 'fab' }) {
  const { user, puede } = useAuth()
  const [open, setOpen] = useState(false)
  const isInline = variant === 'inline'

  // Gate: solo se renderiza si hay user autenticado Y tiene el permiso fino.
  if (!user) return null
  if (typeof puede !== 'function' || !puede('tutoriales', 'grabar')) return null

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Grabar tutorial"
        aria-label="Grabar tutorial"
        className={isInline
          ? 'flex items-center justify-center w-[26px] h-[26px] rounded-md text-purple-400 bg-purple-500/10 hover:bg-purple-500/20 transition-colors'
          : 'fixed bottom-24 right-6 z-[60] w-14 h-14 rounded-full bg-purple-600 hover:bg-purple-500 text-white shadow-lg shadow-purple-600/30 flex items-center justify-center transition-all hover:scale-105 active:scale-95'}
        style={{ display: open ? 'none' : 'flex' }}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={isInline ? 'w-[13px] h-[13px]' : 'w-6 h-6'}>
          {/* Ícono cámara de video */}
          <polygon points="23 7 16 12 23 17 23 7" />
          <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
        </svg>
      </button>

      {/* Portal a document.body: el trigger inline vive dentro del <aside>
          (que tiene transform → containing block) y atraparía al modal fixed.
          El portal lo saca del sidebar y lo centra en el viewport. */}
      {createPortal(
        <TutorialRecorder
          open={open}
          onClose={() => setOpen(false)}
          onSubido={() => { /* el modal se queda en 'done' con el link, el user cierra cuando quiera */ }}
        />,
        document.body
      )}
    </>
  )
}
